import Layout from "@/components/Layout";

function LegalPage({ title, body }) {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <div className="label-mono text-[#002FA7] mb-4">— Legale</div>
        <h1 className="text-4xl font-black tracking-tighter mb-8">{title}</h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          {body}
        </div>
      </div>
    </Layout>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" body={
      <>
        <p><strong>Titolare del trattamento.</strong> EU Logic Lab (MVP di allenamento indipendente). Contatto: support@eulogiclab.eu.</p>
        <p><strong>Dati raccolti.</strong> Email, nome (facoltativo), password (con hash bcrypt), risultati dei test, transazioni di acquisto (identificativo Stripe). Il pagamento avviene su Stripe: non conserviamo dati di carta.</p>
        <p><strong>Base giuridica.</strong> Esecuzione del contratto (art. 6(1)(b) GDPR) per il servizio, obblighi di legge per la fatturazione, consenso (art. 6(1)(a) GDPR) per i cookie di marketing/pubblicità (Google Ads).</p>
        <p><strong>Finalità.</strong> Erogazione del servizio, storico tentativi, gestione acquisti, sicurezza account.</p>
        <p><strong>Diritti dell'interessato.</strong> Accesso, rettifica, cancellazione, portabilità, opposizione. Dalla tua dashboard puoi esportare o cancellare integralmente il tuo account.</p>
        <p><strong>Conservazione.</strong> I dati sono conservati finché il tuo account è attivo. La cancellazione è immediata su richiesta.</p>
        <p><strong>Reclami.</strong> Puoi rivolgerti al Garante per la Protezione dei Dati Personali (garanteprivacy.it) o all'autorità competente del tuo Stato UE.</p>
      </>
    } />
  );
}

export function Terms() {
  return (
    <LegalPage title="Termini di servizio" body={
      <>
        <p>Il servizio EU Logic Lab fornisce test e guide di allenamento originali, non affiliati né supportati da EPSO o dalle istituzioni UE.</p>
        <p>Gli acquisti sono una tantum, non rimborsabili una volta acceduto al contenuto premium (test svolto o guida aperta), salvo casi previsti dalla normativa vigente per i consumatori (diritto di recesso 14 giorni per contenuti digitali non ancora fruiti).</p>
        <p>Le guide premium sono protette da copyright e non possono essere copiate, distribuite o rivendute. Ne è consentita la sola consultazione in-app.</p>
        <p>L'accesso al servizio richiede la registrazione. È vietato condividere le credenziali.</p>
        <p>Ci riserviamo il diritto di sospendere account in caso di uso fraudolento o abusivo.</p>
        <p><strong>Uso di strumenti di intelligenza artificiale.</strong> Il sito e i suoi contenuti (incluse domande, spiegazioni, guide e articoli del blog) sono stati in parte realizzati con il supporto di strumenti di intelligenza artificiale, e successivamente rivisti. I materiali hanno finalità di allenamento e non sostituiscono le comunicazioni ufficiali di EPSO.</p>
      </>
    } />
  );
}

export function Cookies() {
  return (
    <LegalPage title="Cookie Policy" body={
      <>
        <p>Questo sito utilizza cookie tecnici essenziali e, previo tuo consenso, cookie di marketing/pubblicità. Puoi gestire le tue preferenze tramite il banner dei cookie (scelta tra «Accetta tutti» e «Solo essenziali»).</p>

        <p><strong>1. Cookie tecnici essenziali</strong> (sempre attivi, non richiedono consenso ai sensi del GDPR poiché strettamente necessari):</p>
        <ul className="list-disc pl-6">
          <li><code>access_token</code> — sessione autenticata (httpOnly, secure)</li>
          <li><code>refresh_token</code> — rinnovo sessione (httpOnly, secure)</li>
          <li><code>cookie-consent</code> — memorizza le tue preferenze sui cookie</li>
          <li><code>lang</code> — preferenza lingua</li>
        </ul>

        <p><strong>2. Cookie di marketing / pubblicità</strong> (attivati <em>solo</em> dopo il tuo consenso tramite «Accetta tutti»):</p>
        <ul className="list-disc pl-6">
          <li><strong>Google Ads (gtag.js)</strong> — ID account <code>AW-18434067436</code>. Utilizziamo il tag di Google per misurare le conversioni pubblicitarie (es. acquisti completati) e ottimizzare le campagne. Google può impostare cookie quali <code>_gcl_au</code> e cookie sul dominio di Google (es. <code>NID</code>, <code>IDE</code>) a fini di misurazione e pubblicità.</li>
        </ul>
        <p>Titolare del trattamento per questi cookie: Google Ireland Ltd. Per maggiori informazioni consulta la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy di Google</a> e <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="underline">Come Google utilizza i cookie</a>.</p>

        <p><strong>3. Gestione del consenso.</strong> Adottiamo il <em>Google Consent Mode v2</em>: all'apertura del sito i cookie di marketing/analytics sono impostati su «negato» (denied) e vengono attivati solo se scegli «Accetta tutti» nel banner. Selezionando «Solo essenziali» nessun cookie di marketing viene impostato. Puoi modificare in qualsiasi momento la tua scelta cancellando i cookie del browser: al successivo accesso il banner ricomparirà.</p>
      </>
    } />
  );
}
